import React from "react";
import ReactDOM from "react-dom";
import "./SessionExpiredModal.css";

export default function SessionExpiredModal({ open, onConfirm }) {
  if (!open) return null;
  return ReactDOM.createPortal(
    <div className="sem-overlay" role="dialog" aria-modal="true">
      <div className="sem-modal" role="document">
        <h2 className="sem-title">Session expired</h2>
        <p className="sem-text">
          Your session has expired. Please sign in again to continue.
        </p>
        <button className="sem-btn" onClick={onConfirm}>
          Go to login
        </button>
      </div>
    </div>,
    document.body
  );
}
